<template>
    <div class="comp-podcast-list">
        <div class="comp-search-bar">
            <input id="comp-search" class="comp-search-input" v-model="search"
                   placeholder="Cerca un contenuto digitando una parola chiave, una categoria, un relatore o un titolo">
            <div class="comp-search-side">
                <span>Ascoltaci anche su: </span>
                <a href="https://www.spreaker.com/show/attiviamo-energie-positive_1" target="_blank"><img
                        src="../assets/spreaker_icon.png" alt="spreaker"></a>
                <a href="https://open.spotify.com/show/4XUWuxh1khxo0o55j2wche?si=AivKKpefSNyYJe4W2nq8VA"
                   target="_blank"><img src="../assets/spotify_icon.png" alt="spotify"></a>
                <a href="https://podcasts.apple.com/it/podcast/attiviamo-energie-positive/id1505084501" target="_blank"><img
                        src="../assets/apple_icon.png" alt="apple podcast"></a>
            </div>
        </div>
        <div class="comp-category-list" id="comp-list">
            <a v-for="item in eventCategoryList"
               :key="item.id"
               @click.prevent="onCategoryClick(item.id)"
               href="#"
               :class="['comp-category-list__item',{'checked': selectedCategoryList.includes(item.id)}]">
                {{ item.name }}
            </a>
            <div class="comp-category-list__loading" v-if="isLoadingCategories && !isLoadingEvents">
                Attendere...
            </div>
        </div>
        <div class="comp-card-list">
            <masonry :cols="{ default: 2, 768: 1 }" :gutter="16">
                <div v-for="item in eventList" v-bind:key="item.id">
                    <div :id="'podcast-' + item.id" class="comp-card">
                        <div class="comp-card__header">
                            <span class="categories">{{ item.categories.map(x => x.name).join(', ') }}</span>
                            <span class="date">{{ item.date }}</span>
                        </div>
                        <div class="comp-card__body">
                            <div class="player" v-html="item.spreaker_player"/>
                            <h3 class="title" v-html="item.title"/>
                            <div class="content" v-html="item.content"/>
                        </div>
                        <div class="comp-card__footer">
                            <a class="download" target="_blank" v-if="item.download_url" :href="item.download_url">
                                <img src="../assets/download.svg" alt="download">
                                <span v-html="item.download_label || 'Scarica slide & materiali'"></span>
                            </a>
                            <span class="share">
                            <a class="ln" target="_blank" :href="item.spreaker_link">
                                <img src="../assets/link.svg" alt="Condividi link"/></a>
                            <a class="fb"
                               @click.prevent="openShareWindow('https://www.facebook.com/sharer/sharer.php?u='+encodeURI(item.spreaker_link))"
                               target="_blank"
                               :href="'https://www.facebook.com/sharer/sharer.php?u='+encodeURI(item.spreaker_link)">
                                <img src="../assets/facebook.svg" alt="Condividi su facebook"/></a>
                            <a class="tw"
                               @click.prevent="openShareWindow('https://twitter.com/intent/tweet?&url='+encodeURI(item.spreaker_link))"
                               target="_blank"
                               :href="'https://twitter.com/intent/tweet?&url='+encodeURI(item.spreaker_link)">
                                <img src="../assets/twitter.svg" alt="Condividi su twitter"/></a>
                            <a class="wa" target="_blank"
                               :href="'https://web.whatsapp.com/send?text='+encodeURI(item.spreaker_link)"><img
                                    src="../assets/whatsapp.svg" alt="Condividi su whatsapp"/></a>
                        </span>
                        </div>
                    </div>
                </div>
            </masonry>
            <div class="comp-card-list__loading" v-if="isLoadingEvents">
                Attendere...
            </div>
            <div class="comp-card-list__no-results" v-if="eventList.length === 0 && !isLoadingEvents">
                Nessun podcast trovato
            </div>

            <a class="comp-card-list__load-more"
               v-if="hasMore && !isLoadingEvents" @click.prevent="onMoreClick()"
               href="#">
                Carica di più
            </a>
        </div>
    </div>
</template>

<script>
    import {debounce} from "../utils";
    import Vue from 'vue';
    import VueMasonry from 'vue-masonry-css'
    import * as jsonp from "jsonp";

    Vue.use(VueMasonry)

    export default {
        // name: 'PodcastList',
        props: {
            endpoint: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                search: '',
                eventList: [],
                eventCategoryList: [],
                selectedCategoryList: [],
                hasMore: true,
                isLoadingEvents: false,
                isLoadingCategories: false
            }
        },
        mounted() {
            this.fetchCategories()
        },
        watch: {
            search: {
                immediate: true,
                handler(newValue) {
                    if (!this.fetchEventsDebounced) {
                        this.fetchEventsDebounced = debounce(this.fetchEvents, 200)
                    }
                    if (newValue === '') {
                        this.fetchEvents();
                    } else {
                        this.fetchEventsDebounced();
                    }
                }
            }
        },
        methods: {
            getCategoriesEndpoint() {
                return this.endpoint + 'event-categories';
            },
            getEventsEndpoint(isMore = false) {
                let ret = this.endpoint + 'events';
                var criteria = new URLSearchParams();
                if (this.search) {
                    criteria.append('s', this.search);
                }
                if (this.selectedCategoryList.length > 0) {
                    criteria.append('categories', this.selectedCategoryList);
                }
                if (isMore) {
                    criteria.append('offset', '' + this.eventList.length);
                }
                return ret + '?' + criteria.toString();
            },
            fetchEvents(isMore = false) {
                this.isLoadingEvents = true;
                jsonp(this.getEventsEndpoint(isMore), {prefix:'podcast_events', param: '_jsonp', timeout: 0}, (err, data) => {
                    if (err) throw err;
                    if (isMore) {
                        this.eventList = [...this.eventList, ...data.results];
                    } else {
                        this.eventList = data.results
                    }
                    this.hasMore = this.eventList.length < data.count;
                    this.isLoadingEvents = false
                })
            },
            fetchCategories() {
                this.isLoadingCategories = true
                jsonp(this.getCategoriesEndpoint(), {prefix:'podcast_categories',param: '_jsonp', timeout: 0}, (err, data) => {
                    if (err) throw err;
                    this.eventCategoryList = data.results
                    this.isLoadingCategories = false
                });
            },
            onCategoryClick(categoryId) {
                if (this.selectedCategoryList.includes(categoryId)) {
                    this.selectedCategoryList = this.selectedCategoryList.filter(x => x !== categoryId);
                } else {
                    this.selectedCategoryList = [...this.selectedCategoryList, categoryId];
                }
                this.fetchEvents();
            },
            onMoreClick() {
                this.fetchEvents(true)
            },
            openShareWindow(url) {
                window.open(url, 'ShareWindow', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            }

        }
    }
</script>

<style lang="css" scoped>
    .comp-podcast-list {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"
    }

    .comp-search-bar {
        display: flex;
        align-items: center;
    }

    .comp-search-side {
        white-space: nowrap;
        display: flex;
        align-items: center;
        margin-left: auto;
    }

    .comp-search-side span {
        color: #133887;
        font-size: 16px;
        padding-left: 20px;
    }

    .comp-search-side a {
        margin: 0 3px;
    }

    .comp-search-side a img {
        width: 30px;
        padding-left: 10px;
    }

    .comp-search-input {
        border: 1px solid #5A5656;
        border-radius: 3px;
        box-shadow: 0 4px 3px rgba(0, 0, 0, 0.1);
        padding: 24px 60px 20px 20px;
        width: 100%;
        float: left;
        font-size: 16px;
        background-image: url(../assets/search.svg);
        background-size: 26px 26px;
        background-position: right 20px center;
        background-repeat: no-repeat;
        box-sizing: border-box;
    }

    .comp-card {
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
        text-align: left;
        margin-bottom: 50px;
    }

    .comp-card__header {
        padding: 30px 15px;
    }

    .comp-card__body {
        padding: 0 15px 30px 15px;
    }

    .comp-card__footer {
        display: flex;
        align-items: center;
        border-top: 1px solid #E5E5E5;
        padding: 18px 15px;
    }

    .comp-card .date {
        display: block;
        float: right;
        font-size: 14px;
        margin-bottom: 30px;
    }

    .comp-card .categories {
        font-size: 14px;
    }

    .comp-card .title {
        font-size: 16px;
        padding: 25px 0 5px 0;
        margin: 0;
        color: #555555;
    }

    .comp-card .content {
        font-size: 16px;
        padding: 0;
        color: #808080;
        overflow: hidden;
    }

    .comp-card .content a {
        color: #008EFF;
        text-decoration: none;
    }

    .comp-card .share {
        display: flex;
        align-items: center;
        margin-left: auto;
    }

    .comp-card .share img {
        margin-left: 5px;
        width: 15px;
        height: 15px;
    }

    .comp-card .share a.wa img {
        margin-left: 5px;
        width: 18px;
        height: 18px;
    }

    .comp-category-list {
        width: 100%;
        padding: 45px 0 35px 0;
        text-align: left;
        box-sizing: border-box;
    }

    .comp-category-list__item {
        text-decoration: none;
        background-color: white;
        display: inline-block;
        padding: 10px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        border: 1px solid black;
        color: black;
        border-radius: 100px;
        font-size: 16px;
        margin-right: 20px;
        margin-bottom: 10px;
        transition: background-color .3s ease-in-out;
    }

    .comp-category-list__item:hover {
        background-color: #F7F7F9;
    }

    .comp-category-list__item.checked {
        background-color: #ffc425;
        font-weight: bold;
    }

    .comp-card .download img {
        width: 28px;
        height: 28px;
        margin-right: 8px;
    }

    .comp-card .download {
        display: flex;
        align-items: center;
        color: #555555;
        text-decoration: none;
        font-size: 16px;
    }

    .comp-card-list {
        text-align: center;
    }

    .comp-card-list__load-more {
        background-color: white;
        display: inline-block;
        padding: 24px 30px 20px 25px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        border-radius: 100px;
        font-size: 18px;
        margin-right: 20px;
        transition: background-color .3s ease-in-out;
        color: #008EFF;
        text-decoration: none;
        margin: 90px auto 90px auto;
    }

    .comp-card-list__load-more:hover {
        background-color: #F7F7F9;
    }

    @media (max-width: 768px) {
        .comp-search-bar {
            display: block;
        }
/*
        .comp-category-list a {
            width: 100%;
            box-sizing: border-box;
            margin: 4px 0;
        }
*/
        .comp-search-side {
            clear: both;
            margin-top: 30px;
            display: inline-block;
            height: 30px;
        }
    }
</style>
